"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDocumentTitle = void 0;
var react_1 = require("react");
function useDocumentTitle(title) {
    react_1.useLayoutEffect(function () {
        if (typeof title === 'string' && title.trim().length > 0) {
            document.title = title.trim();
        }
    }, [title]);
}
exports.useDocumentTitle = useDocumentTitle;
